import { Link, NavLink } from "react-router-dom";
import { Wrench, Sparkles } from "lucide-react";
import { UserMenu } from "@/components/UserMenu";

const nav = [
  { to: "/", label: "Home", id: "nav-home" },
  { to: "/faqs", label: "FAQ Library", id: "nav-library" },
];

export const Header = () => (
  <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0B0D10]/85 border-b border-[#27303E]" data-testid="site-header">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 md:h-16 flex items-center justify-between gap-4">
      <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
        <span className="w-9 h-9 grid place-items-center bg-amber-500 text-[#0B0D10] rounded-sm transition-transform duration-300 group-hover:rotate-45">
          <Wrench size={18} strokeWidth={2.5} />
        </span>
        <span className="font-display font-extrabold text-2xl uppercase tracking-tight">
          Gear<span className="text-amber-500">Head</span>
        </span>
      </Link>
      <nav className="hidden md:flex items-center gap-8">
        {nav.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end
            data-testid={n.id}
            className={({ isActive }) =>
              `font-mono text-xs uppercase tracking-widest transition-colors duration-200 ${isActive ? "text-amber-500" : "text-slate-400 hover:text-white"}`
            }
          >
            {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="flex items-center gap-3">
        <Link
          to="/ask"
          data-testid="header-ask-ai-btn"
          className="hidden md:inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-[#0B0D10] font-display font-bold uppercase tracking-wide px-4 h-10 rounded-sm transition-colors duration-200"
        >
          <Sparkles size={16} /> Ask AI Mechanic
        </Link>
        <UserMenu />
      </div>
    </div>
  </header>
);
